import FullScreenButton from '@components/fullScreenButton';
import Loading from '@components/loading';
import SectionWidget from '@components/sectionWidget/SectionWidget';
import { ChartWidgetOptions } from '@model/sectionWidget.model';
import { Button, Select, Tooltip } from 'antd';
import React, { useRef, useState, useCallback } from 'react';
import useWidget from 'src/hooks/useWidget';

const Option = Select.Option;

export default function ChartWidgetSection(props) {
  const {
    identifier,
    link,
    setLink,
    saveLink = () => {},
    section,
    titleName,
    // changeOrderPropsValue,
    // onSortEnd,
    // sectionOrder,
    // type,
    // refresh,
  } = props;
  const [chartType, setChartType] = useState(null);
  const [controlledEditStatus, setControlledEditStatus] = useState(false);
  const containerRef = useRef();
  const { widgetId, widgetData, setWidget, saveWidget, isLoading } =
    useWidget(link);

  const handleCreateWidget = async () => {
    const widgetIdasLink = await saveWidget({
      moduleId: identifier,
      moduleType: 'Section',
      chartType,
      data: [],
    });
    saveLink(section, widgetIdasLink);
    setLink(widgetId || 'for button-with-comment-icon location style');
  };

  const handleChangeData = (data) => {
    saveWidget({
      data,
    }).then(() => {
      setControlledEditStatus(false);
    });
  };

  const toggleEdit = useCallback(() => {
    setControlledEditStatus(true);
    setTimeout(() => {
      // eslint-disable-next-line no-unused-vars
      const clickEdit = containerRef.current
        ?.querySelector('.edit-btn')
        ?.click();
    }, 0);
  }, []);

  const onDataChange = (data) => {
    setWidget({
      moduleId: identifier,
      moduleType: 'Section',
      chartType,
      data,
    });
  };

  if (
    (typeof link !== 'string' || link.length === 0) &&
    !widgetData?.chartType
  ) {
    return (
      <>
        <span className="powerbi-title">{titleName}</span>
        <div className="create-widget-action-wrapper">
          <Select
            placeholder="Select visualization type​"
            dropdownClassName="widget-selector-dropdown"
            className="widget-selector"
            dropdownMatchSelectWidth
            value={chartType}
            onChange={setChartType}
          >
            {ChartWidgetOptions.map(({ value, label, icon }) => (
              <Option value={value} key={`chart-option-${value}`}>
                <span className={`appkiticon ${icon} a-font-12`} /> {label}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            style={{
              fontWeight: 500,
              marginLeft: 20,
            }}
            onClick={handleCreateWidget}
            className="role-control"
            disabled={!chartType}
          >
            Create
          </Button>
        </div>
      </>
    );
  }

  return !widgetData ? (
    <Loading style={{ margin: '7.5rem 0' }} />
  ) : (
    <div className="section-widget-wrapper" ref={containerRef}>
      <div className="powerbi-title-link">
        <div className="left">
          <span className="title">{titleName}</span>
        </div>
        <div className="right">
          {!isLoading ? (
            <Tooltip
              title="Edit Visual Data"
              key="edit"
              overlayClassName="edit-visual-button-tooltip"
            >
              <Button
                type="primary"
                className="edit-visual-btn role-control"
                onClick={toggleEdit}
              >
                Edit Visual Data
              </Button>
            </Tooltip>
          ) : null}
          <Tooltip title="Fullscreen" key="fullscreen">
            <div>
              <FullScreenButton
                elemId={`#widgetchartfullscreen-${identifier}`}
              />
            </div>
          </Tooltip>
        </div>
      </div>
      <div
        id={`widgetchartfullscreen-${identifier}`}
        style={{ width: '100%', display: 'flex', alignItems: 'center' }}
      >
        {!isLoading ? (
          <SectionWidget
            chartType={widgetData.chartType}
            data={widgetData.data}
            onDataChange={onDataChange}
            handleSave={handleChangeData}
            controlledEditStatus={controlledEditStatus}
            afterCancel={() => {
              setControlledEditStatus(false);
            }}
            {...props}
          />
        ) : (
          <Loading style={{ textAlign: 'center' }} />
        )}
      </div>
    </div>
  );
}
